import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-grow px-4 py-2 md:px-12 md:py-4 w-full" }


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const nuxtApp = useNuxtApp()
onMounted(() => {
  nextTick(() =>
    document.querySelectorAll('main a').forEach(a => {
      nuxtApp.hooks.callHook('link:prefetch', a.getAttribute('href')!)
    }),
  )
})

return (_ctx: any,_cache: any) => {
  const _component_TheBlogIndex = _resolveComponent("TheBlogIndex")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("header", { class: "leading-none mt-[5vw] mb-[1vw]" }, [
      _createElementVNode("h1", { class: "text-2xl" }, " stuff I've written ")
    ], -1)),
    _createElementVNode("main", {
      id: "main-content",
      class: "text-muted text-lg",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleNavigationClicks && _ctx.handleNavigationClicks(...args)))
    }, [
      _createVNode(_component_TheBlogIndex)
    ])
  ]))
}
}

})